<div
  #wrapper
  class="group relative"
  [class]="{
    'pointer-events-none': !grabbable() || isDragging(),
    'pointer-events-auto': !isDragging(),
    'cursor-grab': !isDragging(),
    'z-10': isDragging(),
  }"
>
  <div
    #el
    [class]="{
      'group-hover:shadow-md': juice() && !isDragging(),
      'shadow-lg': juice() && isDragging(),
      'group-hover:scale-105': juice() && !isDragging(),
      'scale-115': juice() && isDragging() && !isSnapped(),
      'group-hover:-rotate-1': juice() && !isDragging(),
      '-rotate-5': juice() && isDragging() && !isSnapped(),
    }"
    [style]="{
      translate: offset().x + 'px ' + offset().y + 'px',
      transition:
        snapTransition() === 'none'
          ? 'transform 0s, box-shadow 0.2s, scale 0.2s, rotate 0.2s'
          : snapTransition() === 'ease-out'
            ? 'all 0.15s ease-out'
            : 'all 0.3s var(--ease-out-back)',
    }"
  >
    <ng-content></ng-content>
  </div>

  <div
    #draggable="cdkDrag"
    cdkDrag
    class="absolute inset-0"
    (cdkDragStarted)="onDragStarted()"
    (cdkDragMoved)="onDragMoved($event)"
    (cdkDragReleased)="onDragReleased()"
  ></div>
</div>
